module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "numberKeyword"
  }, [_c('ul', [_c('div', {
    staticStyle: {
      "color": "#4ba7e8",
      "float": "right",
      "display": "inline-block",
      "padding": "5px 10px",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._l((_vm.keywordTxt), function(item, index) {
    return _c('li', {
      staticClass: "vux-1px",
      class: {
        greyColor: item == '.'
      },
      on: {
        "click": function($event) {
          _vm.numberKeywordClick(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('li', {
    staticClass: "vux-1px greyColor",
    on: {
      "click": _vm.numberKeyworddel
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "type": "clear"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "numberKeywordMark",
    on: {
      "click": _vm.closePopup
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71919e0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/numberKeyword.vue
// module id = 3Rlu
// module chunks = 5